import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
// components
import LoginModal from "../views/chat/modal/LoginModal";
import Shared from "./Shared";

// utils
import { MyContext } from "../context/MyContext";
import {
  backIncstance,
  generateRandomString,
  getLoginInfo,
} from "../utils/commonFunctions";
// icons
// import Logo from "../assets/icons/icon_logo.svg";
import Hamburger from "../assets/icons/icon_hamburger.png";
import Planet from "../assets/icons/tab_planet.png";
import Mo_Planet from "../assets/icons/tab_planet_mo.png";
import Jisatam from "../assets/icons/logo_earth.png";
import Mo_Jisatam from "../assets/icons/logo_earth_mini.png";
import Coin from "../assets/icons/icon_coin.png";
import CoinClicked from "../assets/icons/icon_coin_clicked.png";
// import Mypage from "../assets/icons/icon_mypage.png";
import Mypage from "../assets/icons/icon_mypage_common.png";
import MypageClicked from "../assets/icons/icon_mypage_clicked.png";
import MyActivity from "../assets/icons/icon_air_activities.png";
import Selected from "../assets/icons/icon_selected.png";
import GuideIcon from "../assets/icons/icon_guide_pc.png";
import GuideNew from "../assets/icons/icon_guide_new.png";
import GuideEvent from "../assets/icons/icon_guide_event_full.png";
import CommonHeaderTop from "./CommonHeaderTop";
import { V2_PAGES, isPageInList } from "../constants/pages";

const LISTS = [
  {
    NAME: "동아사이언스",
    LINK: "/tutor",
    ICON: "https://img.dongascience.com/air/icon_logo.svg",
    ISLOGO: true,
    PATH: "main",
  },
  {
    NAME: "튜터",
    LINK: "/tutor",
    ICON: "https://img.dongascience.com/air/icon_logo.svg",
    ISLOGO: false,
    PATH: "tutor",
  },
  {
    NAME: "소크라테스",
    LINK: "/socrates",
    ICON: "https://img.dongascience.com/air/icon_logo.svg",
    ISLOGO: false,
    PATH: "socrates",
  },
];
const SETTINGS = [
  {
    ID: "login",
    NAME: "가입/로그인",
    LINK: "/login",
    ICON: null,
    ISLOGO: false,
    CLASS: "login",
    REQUIRE_LOGIN: true,
  },
  {
    id: "subscribe",
    NAME: "구독상품안내",
    LINK: `${process.env.REACT_APP_DONGA_STORE}/subscription?anchor=2`,
    ICON: null,
    ISLOGO: false,
    CLASS: "coin",
    EXTERNAL: true,
  },
  {
    id: "subscribe_auth",
    NAME: "구독인증",
    // LINK: '/login',
    LINK: `${process.env.REACT_APP_DONGA_SCHOOL}/auth`,
    ICON: null,
    ISLOGO: false,
    CLASS: "payment",
    EXTERNAL: true,
    TARGET: "_blank",
  },
];

const MYPAGE = [
  // {
  //     NAME: '요금제 안내',
  //     LINK: 'settings/products',
  //     ICON: null,
  //     PATH: 'products'
  // },
  {
    NAME: "이용가이드",
    LINK: "/guide/" + "main", // id 가 생기면 그 때 활용 할 것
    ICON: GuideIcon,
    PATH: "use-guide",
    EXTERNAL: false,
    ISEVENT: true,
    ISNEW: true,
  },
  {
    NAME: "마이페이지",
    LINK: process.env.REACT_APP_DONGA_MYPAGE || "https://my.dongascience.com",
    ICON: Mypage,
    PATH: "my-page",
    EXTERNAL: true,
    REQUIRE_LOGIN: true,
  },
  {
    NAME: "나의 활동",
    LINK: "/my-activity",
    ICON: MyActivity,
    PATH: "my-activity",
    REQUIRE_LOGIN: true,
  },
];
const FAMILY_SITE = {
  MAIN: process.env.REACT_APP_DONGA_MAIN,
  LIBRARY: process.env.REACT_APP_DONGA_LIBRARY,
  STORE: process.env.REACT_APP_DONGA_STORE,
  PLANET: process.env.REACT_APP_DONGA_PLANET,
  AI: process.env.REACT_APP_REFERER_URL,
  JISATAM: process.env.REACT_APP_JISATAM_URL,
  MYPAGE: process.env.REACT_APP_DONGA_MYPAGE,
};

const URLS = {
  LOGOUT: process.env.REACT_APP_LOGOUT_URL,
};
const Header = () => {
  const navigation = useNavigate();
  const location = useLocation();

  // const userInfo = localStorage.getItem('userInfo');

  const {
    setAlertSetting,
    isStartInterview,
    isLogoHidden,
    isSticky,
    navRef,
    setList,
    setStoredList,
    setIsStartInterview,
    clearState,
    user,
    setUser,
    setHistory,
    headerRef,
    isMobile,
    openNav,
    setOpenNav,
    fetching,
    pageName,
    isLogin,
    setIsLogin,
    referrerUrl,
    setReferrerUrl,
    isAppMode,
  } = useContext(MyContext);

  const isRandingPage = location.pathname === "/";
  const isV2 = isRandingPage || isPageInList(location.pathname, V2_PAGES);

  // 240627 로그인 정보 가져오기
  const loginInfo = getLoginInfo();
  const [isShowUserInfo, setIsShowUserInfo] = useState(false);

  const modalRef = useRef(null);

  const logout = async () => {
    const response = await backIncstance("GET", URLS.LOGOUT);
    try {
      if (response.status === 200) {
        setUser((prev) => ({
          ...prev,
          id: null,
          tone: null,
          picture_extension: null,
          picture_data: null,
          name: null,
          paid: false,
          start_dt: null,
          end_dt: null,
          tutor_cnt: 0,
          socra_cnt: 0,
        }));
        sessionStorage.removeItem("userInfo");
        sessionStorage.removeItem("item");
        setHistory([]);
        setList([]);
        setStoredList([]);
        navigation("/");
      } else {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: "다시 시도해주세요.",
          btnTxt: "닫기",
        }));
      }
    } catch {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: "다시 시도해주세요.",
        btnTxt: "닫기",
      }));
    }
  };

  const handleClickLink = (target, item, requireLogin) => {
    if (isStartInterview) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: `페이지를 나가면 면접이 중단됩니다.\n 면접을 끝까지 완료하셔야 평가 리포트를 볼 수 있습니다.`,
        btnTxt: "중단하고 나가기",
        double: true,
        onConfirm: () => {
          if (typeof prev.onConfirm === "function") {
            prev.onConfirm();
          }
          moveToPage(target, item);
          setIsStartInterview(false);
        },
      }));
    } else if (requireLogin && !isValidLogin()) {
      window.location.assign(
        `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${process.env.REACT_APP_REFERER_URL}/tutor`
      );
    } else {
      moveToPage(target, item);
    }
  };

  const moveToPage = (target, item) => {
    if (
      (target === "마이페이지" || target === "나의 활동") &&
      !isValidLogin()
    ) {
      setIsLogin(true);

      // item(link)가 https://로 시작하는 경우 referrerUrl에 저장
      // 경로일 경우, hostname을 포함한 경로를 referrerUrl에 저장
      setReferrerUrl(
        typeof item === "string" &&
          (item.startsWith("http://") || item.startsWith("https://"))
          ? item
          : `${window.location.origin}${item}`
      );
      return;
    }
    // todo 배포시 변경
    if (target === "가입/로그인" && isValidLogin()) {
      setIsShowUserInfo(!isShowUserInfo);
      return;
    }
    // 240627 로그인 정보 가져오기
    if (target === "정기구독인증") {
      alert("정기구독인증 페이지는 준비중입니다.");
      return;
    }
    if (target === "동아사이언스" && isMobile) {
      setOpenNav(!openNav);
    } else {
      setHistory([]);
      // 외부 URL인지 확인 (http:// 또는 https://로 시작하는지)
      if (
        typeof item === "string" &&
        (item.startsWith("http://") || item.startsWith("https://"))
      ) {
        // 외부 URL인 경우 window.location 또는 window.open 사용
        window.open(item, "_blank"); // 새 탭에서 열기
        // 또는 같은 탭에서 이동하려면: window.location.href = item;
      } else {
        // 내부 경로인 경우 React Router의 navigation 사용
        navigation(item, {
          state: {
            from_chat: null,
            is_writed: false,
            is_completed: false,
            his_cnt: 0,
          },
        });
      }
    }
  };

  const [isShowLinks, setIsShowLinks] = useState(false);

  const handleClickInfo = (e) => {
    const target = e.target.id;
    if (target.includes("logout")) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: "로그아웃 하시겠습니까?",
        double: true,
        btnTxt: "로그아웃",
        onConfirm: () => {
          logout();
          if (window.Android?.logout) window.Android.logout();
          clearState();
        },
      }));
    } else {
      setIsShowLinks(true);
    }
  };

  const handleOutsideClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setIsShowUserInfo(false);
    }
  };
  useEffect(() => {
    if (isShowUserInfo) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isShowUserInfo]);

  // 유효한 로그인 상태인지 확인하는 함수
  const isValidLogin = () => {
    // return loginInfo.id && loginInfo.accessToken && user?.id;
    return user && user.id ? true : false;
  };

  const moveToMyPage = () => {
    const url = isValidLogin()
      ? FAMILY_SITE.MYPAGE
      : `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${process.env.REACT_APP_REFERER_URL}`;
    const openNewTab = isAppMode && url === FAMILY_SITE.MYPAGE;

    openNewTab ? window.open(url) : window.location.assign(url);
  };

  function renderUserName(item) {
    if (isValidLogin()) {
      return (
        <span onClick={() => setIsShowUserInfo((prev) => !prev)}>
          {user?.name}님
        </span>
      );
    }

    return <span>{item.NAME}</span>;
  }

  const DetailInfo = (props) => {
    const { handleClickInfo } = props;

    return (
      <ul className="detail-info" onClick={handleClickInfo} ref={modalRef}>
        <li id="link-history">공유 이력 보기</li>
        <li id="logout">로그아웃</li>
      </ul>
    );
  };

  return (
    <div className="hd-wrp" ref={headerRef}>
      {isAppMode ? null : (
        <CommonHeaderTop />
      )}
      {/* hd-tit-wrp 비활성화 - 더 이상 사용하지 않음 */}
      {false && (
        <div className="hd-tit-wrp">
          <div className={`bottom ${!isMobile ? "flx-box sep-elm" : ""}`}>
            {isMobile && (
              <div
                className={`flx-box mo-logo ${isLogoHidden ? "hidden" : ""}`}
              >
                <img
                  src="https://img.dongascience.com/air/icon_logo.svg"
                  alt=""
                />
              </div>
            )}
            {/* <ul className='hd-wrp__nv flx-box'> */}
            <ul className={`hd-wrp__nv flx-box ${isSticky ? "sticky" : ""}`}>
              {LISTS.map((listItem, listIdx) => {
                return (
                  // <li key={generateRandomString(listIdx)} className={`hd-wrp__nv__it ${(listItem.ISLOGO && !isMobile) ? '' : 'crs-btn'}`} id={listItem.NAME} onClick={() => !fetching && handleClickLink(listItem.NAME, listItem.LINK)}>
                  <li
                    key={listItem.PATH}
                    className={`hd-wrp__nv__it ${isMobile ? "" : "crs-btn"}`}
                    id={listItem.NAME}
                    onClick={() =>
                      !fetching && handleClickLink(listItem.NAME, listItem.LINK)
                    }
                  >
                    {listItem.ISLOGO ? (
                      <img
                        className="hd-lg"
                        src={!isMobile ? listItem.ICON : Hamburger}
                        alt={`${listItem.NAME} 아이콘`}
                        style={
                          isMobile
                            ? { width: 24, height: 24, paddingTop: 6 }
                            : undefined
                        }
                      />
                    ) : (
                      <span
                        className="hd-lk"
                        style={
                          pageName === listItem.PATH
                            ? { color: "#4524C9", fontWeight: "700" }
                            : { color: "#6C6C6C" }
                        }
                      >
                        {listItem.NAME}
                      </span>
                    )}
                  </li>
                );
              })}
              {isMobile && (
                <li
                  className={`hd-wrp__nv__it crs-btn`}
                  style={{ position: "absolute", right: 0, marginTop: 6 }}
                  onClick={moveToMyPage}
                >
                  <span className="hd-lk">
                    <img
                      src={Mypage}
                      alt="link-to-mypage"
                      width={24}
                      height={24}
                    />
                    {/* <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.1625 11.3428L3.74625 12.4928C3.34625 12.8865 3.125 13.3153 3.125 13.7503C3.125 15.3578 6.15875 16.8753 10 16.8753C13.8412 16.8753 16.875 15.3578 16.875 13.7503C16.875 13.3153 16.6525 12.8878 16.2538 12.494L16.8488 11.3528C17.655 12.0278 18.125 12.8453 18.125 13.7503C18.125 16.284 14.4425 18.1253 10 18.1253C5.5575 18.1253 1.875 16.284 1.875 13.7503C1.875 12.8403 2.35 12.0203 3.1625 11.3428Z"
                        fill="#212121"
                      />
                      <path
                        d="M3.1625 7.59277L3.74625 8.74277C3.34625 9.13777 3.125 9.56652 3.125 10.0003C3.125 11.6078 6.15875 13.1253 10 13.1253C13.8412 13.1253 16.875 11.6078 16.875 10.0003C16.875 9.56527 16.6525 9.13777 16.2538 8.74402L16.8488 7.60277C17.655 8.27777 18.125 9.09527 18.125 10.0003C18.125 12.534 14.4425 14.3753 10 14.3753C5.5575 14.3753 1.875 12.534 1.875 10.0003C1.875 9.09027 2.35 8.27027 3.1625 7.59277Z"
                        fill="#212121"
                      />
                      <path
                        d="M10 10.625C5.5575 10.625 1.875 8.78375 1.875 6.25C1.875 3.71625 5.5575 1.875 10 1.875C14.4425 1.875 18.125 3.71625 18.125 6.25C18.125 8.78375 14.4425 10.625 10 10.625ZM10 9.375C13.8412 9.375 16.875 7.8575 16.875 6.25C16.875 4.6425 13.8412 3.125 10 3.125C6.15875 3.125 3.125 4.6425 3.125 6.25C3.125 7.8575 6.15875 9.375 10 9.375Z"
                        fill="#212121"
                      />
                    </svg> */}
                  </span>
                </li>
              )}
            </ul>
            {/* {
                      !isMobile ?
                          <div className="flx-box">
                              {MYPAGE.map((item, idx) => {
                                  return (
                                      <div className="hd-wrp__st flx-box">
                                          <div className="hd-wrp__st__it crs-btn" onClick={() => !fetching && handleClickLink(item.NAME, item.LINK)}>
                                              <img src={(idx === 0 && pageName !== item.PATH) ? Coin : (idx === 0 && pageName === item.PATH) ? CoinClicked : (idx === 1 && pageName !== item.PATH) ? Mypage : MypageClicked} alt="link-to-mypage" /><span style={pageName === item.PATH ? { color: '#4524C9', fontWeight: '700' } : { color: '#6C6C6C' }} className="hd-lk">{item.NAME}</span>
                                          </div>
                                      </div>
                                  )
                              })}
                          </div>
                          :
                          <div className={`flx-box mo-logo ${isLogoHidden ? 'hidden' : ''}`}>
                              <img src={Logo} alt="" />
                          </div>
                  } */}
            {!isMobile && (
              <div className="flx-box hd-wrp__nv_right gap-12">
                {MYPAGE.map((item, idx) => {
                  return (
                    <div key={item.NAME} className="hd-wrp__st flx-box">
                      <div
                        className="hd-wrp__st__it crs-btn flx-col"
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() =>
                          !fetching &&
                          handleClickLink(
                            item.NAME,
                            item.LINK,
                            item.REQUIRE_LOGIN ?? false
                          )
                        }
                      >
                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            style={{ width: 32 }}
                            src={item.ICON}
                            alt="link-to-mypage"
                          />
                          {/* {item.ISEVENT && (
                      <span className="event-badge">
                        <img src={GuideEvent} alt="EVENT" style={{ width: '100%', height: '100%' }} />
                      </span>
                    )}
                    {item.ISNEW && (
                      <span className="new-badge">
                        <img src={GuideNew} alt="NEW" style={{ width: '100%', height: '100%' }} />
                      </span>
                    )} */}
                        </div>
                        <span
                          style={
                            pageName === item.PATH
                              ? {
                                  color: "#4524C9",
                                  fontWeight: "700",
                                }
                              : { color: "#6C6C6C" }
                          }
                          className="hd-lk"
                        >
                          {item.NAME}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
      {/* {isLogin && <LoginModal />} */}
      {isShowLinks && <Shared onClose={() => setIsShowLinks(false)} />}
    </div>
  );
};
export default Header;
